import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DropdownMenuItem } from '../../../../DropdownMenu';
import { PRIMARY_ACTION_ICON_SIZE } from '../../table.constants';
export function ActionMenuItem(param) {
    let { action, testId } = param;
    return /*#__PURE__*/ _jsx(DropdownMenuItem, {
        bi: action.bi,
        iconStart: action.icon != null ? /*#__PURE__*/ _jsx(action.icon, {
            size: PRIMARY_ACTION_ICON_SIZE
        }) : undefined,
        disabled: action.disabled,
        intent: action.intent,
        "data-heapid": action.heapId,
        skin: action.destructive === true ? 'error' : undefined,
        tooltipProps: action.tooltip != null ? {
            title: action.tooltip
        } : undefined,
        onClick: (_event, biCallerContext)=>action.onClick(biCallerContext),
        testId: testId,
        children: action.label
    });
}
